import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, switchMap, take, throwError } from 'rxjs';
import { inject } from '@angular/core';

import { BaseAuthService } from '../services/common/base-auth.service';
import { environment } from '../../../environments/environment';
import { CnpjService } from '../services/common/cnpj.service';
import { AuthService } from '@auth0/auth0-angular';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const baseAuth = inject(BaseAuthService);
  const cnpjService = inject(CnpjService);
  const auth0 = inject(AuthService);

  baseAuth.monitorAuthenticationStatus();

  // A API de gestão usa a mesma sessão Auth0, mas não o CNPJ selecionado: as telas de
  // gestão operam sobre toda a base, não sobre a loja escolhida no seletor.
  const isManagerApi = req.url.includes('pharma-manager');
  const isDashApi = req.url.includes('pharma-dash') || req.url.includes('pharma-chat') || req.url.includes('payment-api') || req.url.includes('hiper-agent');

  if (isDashApi || isManagerApi) {
    return auth0.idTokenClaims$.pipe(
      take(1),
      switchMap((claims) => {
        const authToken = claims?.__raw;
        if (authToken) {
          const headers = req.headers.set('Authorization', `Bearer ${authToken}`);
          const selectedCnpj = isDashApi ? cnpjService.getSelectedCnpj() : null;
          const finalHeaders = selectedCnpj ? headers.set('cnpj', selectedCnpj) : headers;
          const authReq = req.clone({ headers: finalHeaders });
          return next(authReq);
        }
        return next(req);
      }),
      catchError((error: HttpErrorResponse) => {
        // Só o pharma-dash é dono da sessão. Um 401 da API de gestão significa que
        // aquela API não aceita o token — não que a sessão do Otimiza morreu.
        if (error.status === 401 && !isManagerApi) {
          baseAuth.logout();
        }
        return throwError(() => error);
      })
    );
  } else if (req.url.includes('lexos-api')) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${environment.TOKEN_LEXOS_API}`)
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  } else if (req.url.includes('autosync')) {
    const authReq = req.clone({
      headers: req.headers.set('x-api-key', `${environment.TOKEN_AUTOSYNC}`)
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  } else if (req.url.includes('integracao.precisaosistemas.com.br')) {
    // Integração Inova/Midas (ativação de precificação, área de gestão).
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${environment.inovaToken}`)
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  } else if (req.url.includes('api.camelai.com')) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${environment.TOKEN_CAMELAI_API}`)
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  return next(req);
};
